/* unplugin-vue-components disabled */const script = {}

const __exports__ = script;

export default __exports__